import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { GhostButton } from 'ui/button';
import { Close16 } from 'ui/icons';
import { TopTooltip } from 'ui/tooltip';
import { BaseOption, BasicFilterSelect } from 'ui/selects';
import { pxToRem } from 'utils/convert';
import { BaseRow } from './SplitEditor.style';
import { getSplitRemoveTestId, getSplitSelectTestId } from './testUtils';

const RowSpacer = styled.div`
  display: flex;
  width: ${pxToRem(480)};
`;

type SplitSelectProps = {
  canRemoveSplits: boolean;
  hasError?: boolean;
  hasFetchedOptions?: boolean;
  isReadOnly?: boolean;
  itemIndex?: number;
  onRemove: (index: number) => void;
  onSelect: (value: string, index: number) => void;
  options: BaseOption<string>[];
  placeholder?: string;
  splitEditor: string;
  value: string;
};

export const SplitSelect: FunctionComponent<React.PropsWithChildren<SplitSelectProps>> = ({
  canRemoveSplits,
  hasError = false,
  hasFetchedOptions = false,
  isReadOnly = false,
  itemIndex = 0,
  onRemove,
  onSelect,
  options,
  placeholder,
  splitEditor,
  value,
}) => (
  <BaseRow>
    <TopTooltip
      isEnabled={hasFetchedOptions && options.length === 0}
      tooltipContent="This project does not have values for this attribute."
    >
      <RowSpacer>
        <BasicFilterSelect
          defaultValues={[value]}
          id={`split-select-${itemIndex}`}
          isReadOnly={isReadOnly}
          onSelect={([val]) => onSelect(val as string, itemIndex)}
          options={options}
          placeholder={placeholder}
          data-test={getSplitSelectTestId(splitEditor, itemIndex)}
          isError={hasError}
          isFullWidth
        />
        {canRemoveSplits && (
          <GhostButton
            onClick={() => onRemove(itemIndex)}
            data-test={getSplitRemoveTestId(splitEditor, itemIndex)}
          >
            <Close16 />
          </GhostButton>
        )}
      </RowSpacer>
    </TopTooltip>
  </BaseRow>
);
